import React from 'react'

export default function CallButton() {
  return <div className="call-btn">
      <a href="tel:+381600737363">Pozovi me</a>
    </div>;
}
